import { aed, pctLabel, type OrderFull, type OrderSettingsRow, type OrderTotals } from "@/lib/orders";
import { OrderStatusPill } from "./ui";

export function SummaryCard({
  order,
  totals,
  settings,
}: {
  order: OrderFull | null;
  totals: OrderTotals | null;
  settings: OrderSettingsRow;
}) {
  const t = totals;
  const rows: Array<[string, number | null, string?]> = [
    ["Floor", t?.floorBase ?? 0],
    ["Floor extras", t?.floorExtrasAmt ?? 0],
    ["Wall", t?.wallBase ?? 0],
    ["Wall extras", t?.wallExtrasAmt ?? 0],
    [`Quantity bracket ${t ? pctLabel(t.bracketPct) : ""}`, t?.bracketAdj ?? 0],
    ["Discount", t ? -t.discountAmt : 0],
  ];
  return (
    <section className="glass-panel-strong p-5">
      <div className="flex items-center justify-between">
        <div>
          <div className="brand-kicker">Order summary</div>
          <div className="font-serif text-lg text-paper">{order?.number ?? "New order"}</div>
        </div>
        {order && <OrderStatusPill status={order.status} />}
      </div>
      <table className="mt-4 w-full text-sm">
        <tbody>
          {rows.map(([label, value]) => (
            <tr key={label} className="border-b border-white/8">
              <td className="py-1.5 text-ice/70">{label}</td>
              <td className="num py-1.5 text-right text-paper/90">{value && value < 0 ? `− ${aed(-value)}` : aed(value)}</td>
            </tr>
          ))}
          <tr className="border-b border-white/8">
            <td className="py-1.5 font-semibold text-paper">Net</td>
            <td className="num py-1.5 text-right font-semibold text-paper">{aed(t?.net)}</td>
          </tr>
          <tr className="border-b border-white/8">
            <td className="py-1.5 text-ice/70">VAT {settings.vatPct}%</td>
            <td className="num py-1.5 text-right text-paper/90">{aed(t?.vatAmt)}</td>
          </tr>
        </tbody>
      </table>
      <div className="mt-3 flex items-baseline justify-between rounded-xl bg-night/70 px-4 py-3">
        <span className="text-[0.62rem] font-semibold uppercase tracking-[0.2em] text-goldbright">Total AED</span>
        <span className="num font-serif text-2xl text-goldbright">{aed(t?.total)}</span>
      </div>
      <div className="mt-2 flex justify-between text-xs text-ice/70">
        <span>Deposit {settings.depositPct}% on confirmation</span>
        <b className="num text-paper">{aed(t?.depositAmt)}</b>
      </div>
      <div className="flex justify-between text-xs text-ice/70">
        <span>Balance on completion</span>
        <b className="num text-paper">{aed((t?.total ?? 0) - (t?.depositAmt ?? 0))}</b>
      </div>
    </section>
  );
}
